import { css } from "@emotion/css";
import { useEffect, useRef } from "react";
import { isNotUndefined, isUndefined } from "./FunctionsCore";
const addIfNotNull = (re) => (ht) => {
    if (ht !== null) {
        re.current.push(ht);
    }
};
const createMinHeightClass = (minHeight) => (isNotUndefined(minHeight) ? css({ "minHeight": minHeight }) : void 0);
const getMaxHeight = (reference) => {
    const offsetHeightArray = reference.current.map((ht) => ht === null || ht === void 0 ? void 0 : ht.offsetHeight);
    const offsetHeightNumberArray = offsetHeightArray.filter((nu) => typeof nu === "number");
    return offsetHeightArray.length === offsetHeightNumberArray.length ? window.Math.max(...offsetHeightNumberArray) : void 0;
};
const updateMinHeight = (maxHeight, re) => {
    re((nu) => (isUndefined(maxHeight) ? nu : (isUndefined(nu) ? maxHeight : window.Math.max(nu, maxHeight))));
};
const filterOutUndefineds = (array) => {
    const newArray = [];
    for (const va of array) {
        if (isNotUndefined(va)) {
            newArray.push(va);
        }
    }
    return newArray;
};
// https://stackoverflow.com/questions/28889826/how-to-set-focus-on-an-input-field-after-rendering/54159564#54159564
const useFocus = () => {
    const reference = useRef(null);
    const performFocus = () => {
        const current = reference.current;
        if (current !== null) {
            current.focus();
        }
    };
    return [reference, performFocus];
};
// https://stackoverflow.com/questions/53179075/with-useeffect-how-can-i-skip-applying-an-effect-upon-the-initial-render/53180013#53180013
const useDidUpdateEffect = (effect, deps) => {
    const didMountReference = useRef(false);
    useEffect(() => {
        if (didMountReference.current) {
            return effect();
        }
        didMountReference.current = true;
    }, deps);
};
var LoadingState;
(function (LoadingState) {
    LoadingState[LoadingState["Completed"] = 0] = "Completed";
    LoadingState[LoadingState["InProgress"] = 1] = "InProgress";
    LoadingState[LoadingState["Initial"] = 2] = "Initial";
})(LoadingState || (LoadingState = {}));
export { addIfNotNull, createMinHeightClass, filterOutUndefineds, getMaxHeight, LoadingState, updateMinHeight, useDidUpdateEffect, useFocus };
